import { useState, useRef, useEffect } from "react";
import './index.less'
import { methodOfPay } from "./const"
import { Dialog, Toast, Image, Popup, Button, Input } from 'antd-mobile'
import { DialogShowHandler } from 'antd-mobile/es/components/dialog'
import { jumpPage, throttle, onToUserPage } from "@/utils/common";
import { store } from '@/store'
import storeUserInfo from "@/store/userInfo/action"
// 组件
import NavBar from '@/component/NavBar/NavBar';
// 图片
import diamondPng from "@/image/recharge/diamond.svg"
import questionPng from '@/image/recharge/question.svg'
import uncheck_box from '@/image/common/uncheck_box.svg'
import check_box from '@/image/common/check_box.svg'
import back from '@/image/common/back.svg'
import close from '@/image/common/close.svg'
import close2 from '@/image/common/close2.svg'
import phone from '@/image/common/phone.svg'
import uu from '@/image/common/uu.png'
// api
import { postActivityDetail } from '@/api/invite'
import { getPayMethod, getProductList, postTopUp, createOrder } from "@/api/recharge";
import { postMobileWebCode, postLogin, getUserInfo } from '@/api/user';

const AppRecharge = () => {
  const [token, setToken] = useState(localStorage.getItem('token'))
  const handler = useRef<DialogShowHandler>()
  const [active, setActive] = useState(0)
  const [method, setMethod] = useState('Alipay')
  const [env] = useState(process.env.REACT_APP_ENV_VERSION)
  // const inputRef = useRef(null);
  let ui = localStorage.getItem('userInfo')
  ui = ui && ui !== 'undefined' ? JSON.parse(localStorage.getItem('userInfo') as string) : {}
  const [userInfo, setUserInfo] = useState<any>(ui)
  const [listOfAmounts, setListOfAmounts] = useState([{
    amount: 0,
    description: "",
    diamond_num: 0,
    product_code: "",
    points: 0,
    ruyi_token: 0,
  }])
  const [check, setCheck] = useState<boolean>(false)

  // function getValue(input: any) {
  //   if (typeof input === 'object') return input.value
  // }

  // const accountDialog = () => {
  //   handler.current = Dialog.show({
  //     content: (
  //       <>
  //         <h3 className="dialog-title">充值账号</h3>
  //         <section>
  //           <input ref={inputRef} type="number" name="user_id" placeholder="请输入UU语音账户ID" />
  //         </section>
  //       </>
  //     ),
  //     // closeOnAction: true,
  //     actions: [
  //       [
  //         {
  //           key: 'cancel',
  //           text: '取消',
  //           onClick: () => {
  //             handler.current?.close()
  //           },
  //         },
  //         {
  //           key: 'confirm',
  //           text: '确定',
  //           bold: true,
  //           disabled: false,
  //           onClick: () => {
  //             const user_id = Number(getValue(inputRef.current))
  //             if (user_id) {
  //               getUserViewInfo(user_id).then((e:any) => {
  //                 // 存在localStorage里面是被充值账户的信息，而存在redux里面的是本账户的信息
  //                 localStorage.setItem('userInfo', JSON.stringify(e))
  //                 setUserInfo(e)
  //                 handler.current?.close()
  //               }).catch(() => {})
  //             } else Toast.show('请先填写账户ID')
  //           },
  //         },
  //       ],
  //     ],
  //   })
  // }

  // 获取支付code
  const triggerGetPayMethod = () => {
    return getPayMethod(method === 'WeChat' ? 'wechat_miniapp' : 'h5').then(e => e);
  }

  // 支付宝支付
  const triggerTopUp = async () => {
    const data = {
      client_os: method === 'WeChat' ? 'wechat_miniapp' : 'h5',
      product_code: listOfAmounts[active].product_code,
      to_user_id: userInfo.user_id,
      // diamond_num: mount.value,
      // amount: money.value * 100,
    }

    const payMethod = await triggerGetPayMethod()
    const payResult = await postTopUp(data);

    if (payMethod?.asset_type_code && payMethod?.asset_product_code && payResult?.biz_no) {
      const { asset_type_code, asset_product_code } = payMethod;
      const { user_id, biz_no, amount, biz_notify_url, expire_at_time, third_user_id, auth_app_id } = payResult;

      if (method === 'WeChat') {
        // 正式版为release，体验版为trial，开发版为develop
        const queryString = `biz_no=${biz_no}&amount=${amount}&user_id=${userInfo.user_id}`;

        try {
          window.location.href = `weixin://dl/business/?appid=wx42296866733afa0c&path=pages/recharge/recharge&query=${encodeURIComponent(queryString)}&env_version=${env}`
        } catch (error:any) {
          console.error(error)
          Toast.show('请先安装最新版本的UU语音！')
        }

        return
      }

      createOrder({
        asset_type_code,
        asset_product_code,
        uid: user_id,
        biz_no,
        goods_name: `${listOfAmounts[active].diamond_num}钻石`,
        goods_desc: '',
        amount,
        biz_notify_url,
        expire_at_time,
        client_os: method === 'WeChat' ? 'wechat_miniapp' : 'h5',
        return_url: window.location.href.split('?')[0],
        third_user_id,
        auth_app_id,
      }).then(e => {
        // 触发支付宝支付api
        try {
          // window.location.href = `alipays://platformapi/startapp?appId=20000067&url=${encodeURIComponent(e.url)}`
          if (e.alipay_response.url) window.location.href = `${e.alipay_response.url}`
        } catch (error: any) {
          Toast.show(error)
        }
      })
    } else {
      triggerGetPayMethod()
      if (payResult?.biz_no) Toast.show('支付方式获取中，请稍后再试！')
    }
  }

  const confirmPay = () => {
    if (!token) return setVisible(true)
    else if (!check) return Toast.show('请先查看并同意充值协议')

    handler.current = Dialog.show({
      content: (
        <>
          <h3 className="dialog-title">确认充值</h3>
          <section>
            <p>是否为ID为 <span style={{fontWeight:'bold'}}>{userInfo.user_id}</span>，昵称为 <span style={{fontWeight:'bold'}}>{userInfo.user_nickname}</span> 的账号充值￥ <span style={{color:'#E90000'}}>{listOfAmounts[active]?.amount}</span>？</p>
          </section>
        </>
      ),
      // closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: '取消',
            onClick: () => {
              handler.current?.close()
            },
          },
          {
            key: 'confirm',
            text: '确定',
            bold: true,
            onClick: () => {
              triggerTopUp()
              handler.current?.close()
            },
          },
        ],
      ],
    })
  }

  const buttonClick1 = () => {
    jumpPage('/app-value-notice')
  }

  const [visible, setVisible] = useState<boolean>(!localStorage.getItem('token'))
  const [step, setStep] = useState<number>(0)
  const [time, setTime] = useState<number>(60)
  const [timer, setTimer] = useState<NodeJS.Timeout | null>(null)
  const [mobile, setMobile] = useState<string>('')
  const [code, setCode] = useState<string>('')
  const [verifyText, setVerifyText] = useState<string>('获取验证码')
  const [hintMobileText, setHintMobileText] = useState<string>('')
  const [showCaptcha, setShowCaptcha] = useState<boolean>(false)

  const quickLogin = () => {
    if (!check) return Toast.show('请先查看并同意充值协议')
    
    onToUserPage(window.location.href, 'recharge_open_native')
  }

  const login = () => {
    if (!check) return Toast.show('请先查看并同意充值协议')

    postLogin({
      mobile,
      code,
    }).then(async (e:any) => {
      const { token } = e;
      if(token && token !== 'undefined') {
        localStorage.setItem("token", token);
        localStorage.setItem("userInfo", JSON.stringify(e));
        let action = storeUserInfo.setUserInfo(e)

        postActivityDetail({
          activity_code: 'YQ001'
        }).then(e2 => {
          const obj = { ...e, invite_code: e2 ? e2.pretty_number : '' }
          localStorage.setItem("userInfo", JSON.stringify(obj));
          action = storeUserInfo.setUserInfo(obj)
        }).finally(() => {
          store.dispatch(action)
          handler.current?.close()
        })

        setToken(token)
        setUserInfo(e)
        setVisible(false)
        Toast.show({ icon: 'success', content: '登录成功！' })
      }
    })
  }

  const triggerTimer = () => {
    let newTime = time - 1
    setTime(newTime)

    setInterval(() => {
      if (time <= 60 && time > 1) {
        setVerifyText(newTime.toString() + 's')
        newTime = newTime - 1
        setTime(newTime)
      } else {
        if (timer) clearInterval(timer)
        setTime(60)
        setVerifyText('获取验证码')
        setTimer(null)
      }
    }, 1000)
  }

  const verifyMobile = () => {
    if (!/^1[3-9]\d{9}$/.test(mobile)) {
      setHintMobileText('手机号格式不正确')
      return false
    } else {
      setHintMobileText('')
      return true
    }
  }

  const verifyTriggerSend = () => {
    if (verifyMobile() && time === 60) {
      setShowCaptcha(true)
    }
  }

  const sendVerify = (ticket:string, rand_str:string) => {
    if (verifyMobile() && time === 60) {
      postMobileWebCode({ mobile, ticket, rand_str }).then(() => {
        triggerTimer()
        Toast.show({
          icon: 'success',
          content: '验证码发送成功！',
        })
      })
    }
  }

  useEffect(() => {
    getProductList().then(e => {
      setListOfAmounts(e.list)
    })
  }, [])

  useEffect(() => {
    if (token && !userInfo?.user_id) {
      // 如果拿到了token，就根据token直接获取用户信息
      getUserInfo().then(e => {
        // 存在localStorage里面是被充值账户的信息，而存在redux里面的是本账户的信息
        localStorage.setItem("userInfo", JSON.stringify(e));
        let action = storeUserInfo.setUserInfo(e)

        postActivityDetail({
          // activity_code: 'YQ002'
          activity_code: 'YQ001'
        }).then(e2 => {
          const obj = { ...e, invite_code: e2.pretty_number }
          localStorage.setItem("userInfo", JSON.stringify(obj));
          action = storeUserInfo.setUserInfo(obj)
        }).finally(() => {
          store.dispatch(action)
        })

        setUserInfo(e)
      }).catch(() => {})
    }
  }, [token, userInfo?.user_id])

  useEffect(() => {
    const iframe:any = document.getElementById('myIframe');

    const iframeClose = () => {
      setShowCaptcha(false)
    }

    iframe?.contentWindow.addEventListener('close', iframeClose);

    const iframeCaptchaResult = (event:any) => {
      iframeClose()
      sendVerify(event.detail?.ticket, event.detail?.randstr)
    }

    iframe?.contentWindow.addEventListener('captchaResult', iframeCaptchaResult);

    return () => {
      window.removeEventListener('close', iframeClose);
      window.removeEventListener('captchaResult', iframeCaptchaResult);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showCaptcha])

  return (
    <div className="app-recharge-content-page">
      <NavBar title="充值" rightButton="充值说明" imageUrl={questionPng} buttonClick={buttonClick1} />

      <section className="app-recharge-content">
        <h3>账户充值</h3>
        <nav className="account-info">
          {
            userInfo.user_id ?
            <>
              <aside>
                <Image className="head-portrait" src={userInfo.avatar} fit='contain' />
                <div>
                  <h3>{userInfo.user_nickname}</h3>
                  <p>ID:{userInfo.user_id}</p>
                </div>
              </aside>
              {/* <span onClick={accountDialog}>切换账号</span> */}
            </> : ''
            // <button className="middle-btn primary-botton" onClick={accountDialog}>选择账户</button>
          }
        </nav>

        <h3>
          选择充值金额
          <span>*未成年人禁止充值消费</span>
        </h3>
        <p>平台不会以任何形式要求用户转账汇款、索要账号信息(账号、密码、验证码等)、向他人账号充值以及许诺充值返利活动，请大家提高警惕，谨防诈骗!</p>
        <ul>
          {listOfAmounts.map((item, index) => (
            <li className={active === index ? 'active-btn' : ''} key={index} onClick={() => setActive(active => active = index)}>
              <img src={diamondPng} alt="" />
              <span>{item.diamond_num}</span>
              <span>￥{item.amount}.00</span>
              {item.points ? <span>获得{item.points}积分</span> : ''}
              {item.ruyi_token ? <span className="superscript">赠送{item.ruyi_token}如意令</span> : ''}
            </li>
          ))}

          <li />
        </ul>

        <h3>选择充值方式</h3>
        <nav className="recharge-methods">
          {/* {methodOfPay.filter(e => !isiOS || e.value !== 'WeChat' ).map((item, index) => ( */}
          {methodOfPay.map((item, index) => (
            <div className={method === item.value ? 'active-btn img-btn' : 'img-btn'} key={index} onClick={() => setMethod(method => method = item.value)}>
              <img src={item.imgUrl} alt="" />
              <span>{item.name}</span>
            </div>
          ))}
        </nav>

        <button className="big-btn" onClick={confirmPay}>立即充值</button>
 
        <footer>
          <Image src={check ? check_box : uncheck_box} fit='contain' onClick={() => setCheck(!check)} />
          <p onClick={() => setCheck(!check)}>我已详细阅读并同意</p>
          <span onClick={() => jumpPage('/app-recharge-agreement')}>《UU语音充值协议》</span>
        </footer>
      </section>

      {/* 充值需登录UU语音账号 */}
      <Popup
        className="login-popup"
        visible={visible}
        onMaskClick={() => {
          setVisible(false)
        }}
      >
        <header>
          {
            step === 1 ?
            <Image src={back} fit='contain' onClick={() => setStep(0)} /> :
            <div className="placeholder-box" />
          }
          <h3>充值需登录UU语音账号</h3>
          <Image src={close} fit='contain' onClick={() => setVisible(false)} />
        </header>

        {
          step === 1 ?
          <section>
            <div>
              <span>+86</span>
              <Input
                placeholder="请输入手机号"
                name="mobile"
                value={mobile}
                clearable
                clearIcon={<Image src={close2} className="close2" fit='contain' />}
                onChange={val => setMobile(val.substring(0,11))}
              />
            </div>
            {
              hintMobileText ? 
              <p className="hint-text">{hintMobileText}</p> : ''
            }
            <div className="special-line">
              <Input
                type="number"
                placeholder="请输入验证码"
                name="code"
                value={code}
                clearable
                clearIcon={<Image src={close2} className="close2" fit='contain' />}
                onChange={val => setCode(val.substring(0,6))}
              />
              <Button className={'sendVerify ' + (verifyText !== '获取验证码' ? 'countdown' : '')} disabled={!mobile} fill="none" onClick={verifyTriggerSend}>{verifyText}</Button>
            </div>
          </section> :
          <Image src={uu} className="uu" fit='contain' />
        }

        {
          step === 1 ?
          <Button disabled={!mobile || !code} color='primary' fill='solid' onClick={() => throttle(login)}>登录</Button> :
          <Button color='primary' fill='solid' onClick={() => throttle(quickLogin)}>UU语音快捷登录</Button>
        }

        {
          step === 0 ?
          <aside className="login-method" onClick={() => setStep(1)}>
            <Image src={phone} fit='contain' />
            手机号登录
          </aside> : ''
        }

        <footer>
          <Image src={check ? check_box : uncheck_box} fit='contain' onClick={() => setCheck(!check)} />
          <p onClick={() => setCheck(!check)}>我已详细阅读并同意</p>
          <span onClick={() => jumpPage('/app-recharge-agreement')}>《UU语音充值协议》</span>
        </footer>
      </Popup>

      {
        showCaptcha ?
        <iframe title="登录验证" id="myIframe" src={'/captcha/index.html'} className="captcha-iframe" /> : ''
      }
    </div>
  )
}

export default AppRecharge